import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon } from 'lucide-react';
interface BIKPIProps {
  title: string;
  value: string | number;
  trend?: number;
  icon?: React.ReactNode;
  color?: 'blue' | 'teal' | 'emerald' | 'amber' | 'red' | 'purple';
  delay?: number;
}
export function BIKPI({
  title,
  value,
  trend,
  icon,
  color = 'blue',
  delay = 0
}: BIKPIProps) {
  const colorMap = {
    blue: 'text-blue-400 bg-blue-500/20 border-blue-500/30',
    teal: 'text-teal-400 bg-teal-500/20 border-teal-500/30',
    emerald: 'text-emerald-400 bg-emerald-500/20 border-emerald-500/30',
    amber: 'text-amber-400 bg-amber-500/20 border-amber-500/30',
    red: 'text-red-400 bg-red-500/20 border-red-500/30',
    purple: 'text-purple-400 bg-purple-500/20 border-purple-500/30'
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay
  }} className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl border border-white/10 p-5 flex flex-col" data-id="element-671" data-mp="6u5s8ah0hsr5">
      <div className="flex items-start justify-between mb-3" data-id="element-672" data-mp="2k4tcxyui9mmb">
        <p className="text-blue-300/80 text-sm font-medium" data-id="element-673" data-mp="2z33ts21knffa">{title}</p>
        {icon && <div className={`p-2 rounded-lg border ${colorMap[color]}`} data-id="element-674" data-mp="2z115pnjzbwd7">
            {icon}
          </div>}
      </div>

      <div className="mt-auto flex items-end justify-between" data-id="element-675" data-mp="26eg6k0x9ifz3">
        <h4 className="text-2xl font-bold text-white" data-id="element-676" data-mp="26eycxqdn2akq">{value}</h4>

        {trend !== undefined && <div className={`flex items-center text-xs font-medium px-2 py-1 rounded-full ${trend > 0 ? 'bg-emerald-500/20 text-emerald-400' : trend < 0 ? 'bg-red-500/20 text-red-400' : 'bg-white/10 text-blue-300'}`} data-id="element-677" data-mp="21gwsb10ke375">
            {trend > 0 ? <TrendingUpIcon size={12} className="mr-1" data-id="element-678" data-mp="2bbopw4u5cq1x" /> : trend < 0 ? <TrendingDownIcon size={12} className="mr-1" data-id="element-679" data-mp="1nmnnay7zw94k" /> : <MinusIcon size={12} className="mr-1" data-id="element-680" data-mp="1iovlnchjt8n6" />}
            {Math.abs(trend)}%
          </div>}
      </div>
    </motion.div>;
}